import React from "react";
import { usePage } from "@inertiajs/react";
import { TranslationProvider } from "@/components/TranslationContext";

/**
 * Global layout that provides translations reactively.
 * usePage() re-renders on every Inertia navigation, so translations always fresh.
 */
const AppLayout = ({ children }: { children: React.ReactNode }) => {
    const { translations } = usePage().props as any;
    return (
        <TranslationProvider translations={translations || {}}>
            {children}
        </TranslationProvider>
    );
};

export default AppLayout;
